<template>
  <v-container class="pa-0">
    <div class="text-h6">Om dig</div>
    <v-row>
      <v-col>
        <v-textarea
          label="Presentation"
          outlined
          v-model="data.presentation"
          :rules="[formRules.required,formRules.maxLength(data.presentation, 2000)]"
          required
          :auto-grow="true"
          counter
        ></v-textarea>
        <v-textarea
          label="Yrkeserfarenhet"
          outlined
          v-model="data.professionExperience"
          :rules="[formRules.required,formRules.maxLength(data.professionExperience, 2000)]"
          required
          :auto-grow="true"
          counter
        ></v-textarea>
      </v-col>
    </v-row>
    <div class="text-h6">Kvalifikationer</div>
    <v-row>
      <v-col>
        <!--qualification-form-fields-->
        <app-qualification-form-fields :data="data" mode="matching" :newFileRows="newFileRows"></app-qualification-form-fields>
      </v-col>
    </v-row>
    <div class="text-h6">Geografiskt tillgänglighet</div>
    <v-row>
      <v-col>
        <!--mile radius-->
        <v-checkbox
          class="mt-0"
          v-model="data.matchByMileRadius"
          label="Jag vill endast matchas mot jobb inom en viss milsradie"
        >
        </v-checkbox>
        <template v-if="data.matchByMileRadius">
          <div class="text-subtitle-1 mb-2">Milsradie</div>
          <v-text-field
            label="Ange mil"
            outlined
            suffix="mil"
            type="number"
            v-model="data.mileRadius"
            :rules="data.matchByMileRadius ? [formRules.required, formRules.positiveInteger(data.mileRadius, { min: 1, max: 1000 })] : []"
            :required="data.matchByMileRadius"
            min="1"
            max="1000"
            maxlength="4"
            class="xAmount"
          ></v-text-field>
          <!--google-map-->
          <app-google-map
            :markers="markers"
            :addMarkerButtons="addMarkerButtons"
            :data="data.mapData"
            label="Ange din adress"
            :useMap="false"
          ></app-google-map>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { generalMixin } from '../mixins/general'
import { urlMixin } from '../mixins/url'
import GoogleMap from '../components/GoogleMap'
import QualificationFormFields from '../components/QualificationFormFields'

export default {
  components: {
    'app-qualification-form-fields': QualificationFormFields,
    'app-google-map': GoogleMap,
  },
  mixins: [generalMixin, urlMixin],
  props: {
    data: {
      type: Object,
      required: true
    },
    newFileRows: {
      type: Object,
      required: true
    },
    /*
    elementData: {
      type: Object,
      required: true
    }
    */
  },
  data() {
    return {
      markers: [
        {
          label: 'homePos',
          position: null,
          name: 'Utgångsposition',
          icon: {
            url: require('../assets/markers/home.png'),
            scaledSize: {width: 64, height: 64},
            labelOrigin: {x: 16, y: -10}
          }
        }
      ],
      addMarkerButtons: [
        {
          label: 'homePos',
          text: 'Bekräfta utgångsposition'
        }
      ],
    }
  },
  methods: {
  },
  mounted() {
    //possibly update positions in markerData
    let label, position
    for (let marker of this.markers) {
      label = marker.label
      position = this.data.mapData[label]
      if (position.lat !== 0 && position.lng !== 0) {
        //label has real position, update marker in markers (that is invoked in google-map)
        marker.position = position
      }
    }
  }
}
</script>

<style>

</style>